import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {EnvelopeShippingDocumentsComponent } from './envelope-shipping-documents.component';

const routes: Routes = [
  {
    path: '',
    component:EnvelopeShippingDocumentsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EnvelopeShippingDocumentsRoutingModule {}
